var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { Getter, Mutation, State, namespace } from "vuex-class";
import NumberRange from "~/components/common/number-range.vue";
import { TelCaseManageService } from "~/services/domain-service/tel-case-manage.service";
import CaseAllot from "~/components/distribution-common/case-allot.vue";
import { CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import { LabelingStrategyService } from "~/services/dataimp-service/labeling-strategy-service";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import PrincipalRecovery from "~/components/apply-component/principal-recovery.vue";
var AllotModule = namespace("case-allot");
var TelWaitingCollectCaseManage = /** @class */ (function (_super) {
    __extends(TelWaitingCollectCaseManage, _super);
    function TelWaitingCollectCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fromChanel = CASE_CHANNEL.tel;
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            compensationMoney: {
                max: "",
                min: ""
            },
            loanDate: [],
            principalId: '',
            partCollectionRemainingDays: { min: '', max: '' },
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            overdueDays: {
                max: "",
                min: ""
            },
            partnerName: '',
            batchNumber: ''
        };
        _this.dataSet = [];
        _this.selectionList = [];
        _this.options = [];
        _this.dialog = {
            ManualDivision: false,
            principalRecovery: false
        };
        return _this;
    }
    TelWaitingCollectCaseManage.prototype.created = function () {
        this.refreshData();
    };
    TelWaitingCollectCaseManage.prototype.refreshData = function () {
        var _this = this;
        this.telCaseManageService
            .waitDistribution(this.paramsHandler(), this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    TelWaitingCollectCaseManage.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.compensationMoneyMax = this.model.compensationMoney ? this.model.compensationMoney.max : "";
        params.compensationMoneyMin = this.model.compensationMoney ? this.model.compensationMoney.min : "";
        params.overdueDaysMax = this.model.overdueDays ? this.model.overdueDays.max : "";
        params.overdueDaysMin = this.model.overdueDays ? this.model.overdueDays.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        delete params.compensationMoney;
        delete params.overdueDays;
        delete params.partCollectionRemainingDays;
        delete params.followInTime;
        delete params.loanDate;
        return params;
    };
    Object.defineProperty(TelWaitingCollectCaseManage.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 范围输入框的重置
     */
    TelWaitingCollectCaseManage.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.compensationMoney = { min: "", max: "" };
        this.model.overdueDays = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: '', max: '' };
    };
    /**
     * 手动分案
     */
    TelWaitingCollectCaseManage.prototype.manualDivision = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        this.updateCaseIds(this.selectionList.map(function (v) { return v.id; }));
        this.dialog.ManualDivision = true;
    };
    /**
     * 进入查看执行页
     */
    TelWaitingCollectCaseManage.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Tel_await,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 委托方回收
     */
    TelWaitingCollectCaseManage.prototype.dealManualPartReturnCase = function () {
        if (this.selectionList.length !== 0) {
            this.dialog.principalRecovery = true;
        }
        else {
            this.$message("\u8BF7\u9009\u62E9\u8981\u8FDB\u884C\u59D4\u6258\u65B9\u56DE\u6536\u7684\u6848\u4EF6");
        }
    };
    __decorate([
        Dependencies(PageService)
    ], TelWaitingCollectCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], TelWaitingCollectCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(TelCaseManageService)
    ], TelWaitingCollectCaseManage.prototype, "telCaseManageService", void 0);
    __decorate([
        Dependencies(LabelingStrategyService)
    ], TelWaitingCollectCaseManage.prototype, "labelingStrategyService", void 0);
    __decorate([
        Mutation
    ], TelWaitingCollectCaseManage.prototype, "updateCollectionType", void 0);
    __decorate([
        Getter
    ], TelWaitingCollectCaseManage.prototype, "callDepartmentData", void 0);
    __decorate([
        AllotModule.Mutation
    ], TelWaitingCollectCaseManage.prototype, "updateCaseIds", void 0);
    __decorate([
        State
    ], TelWaitingCollectCaseManage.prototype, "principalList", void 0);
    TelWaitingCollectCaseManage = __decorate([
        Auth(201),
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange,
                CaseAllot: CaseAllot,
                GetLabelName: GetLabelName,
                PrincipalRecovery: PrincipalRecovery
            }
        })
    ], TelWaitingCollectCaseManage);
    return TelWaitingCollectCaseManage;
}(Vue));
export default TelWaitingCollectCaseManage;
